// src/components/kuestion/campus/Billing.jsx
// Shape only. Billing stays with the examiner (contract §3); students never
// hold a balance and never see this section. Wire to billingdb when built.
import React from 'react';
import { Stat } from '../shared/Bits';

export default function Billing() {
  return (
    <div className="kqc-page kqc-page--narrow">
      <div className="kqc-row" style={{ marginBottom: 10 }}>
        <span className="kqc-kicker">Billing</span>
        <span className="tag tag-outline">Not built yet — shape only</span>
      </div>
      <h1 className="kqc-h1" style={{ marginBottom: 12 }}>Plan &amp; usage</h1>
      <p className="kqc-lede" style={{ marginBottom: 26 }}>Billing stays with you, the examiner. Students never hold a balance and never see this section — the student app has no rail entry for it at all.</p>

      <div className="kqc-stats" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
        <Stat label="Plan" value="—" size="md" />
        <Stat label="Token balance" value="—" />
        <Stat label="Next invoice" value="—" size="md" />
      </div>

      <div className="table-wrap" style={{ marginBottom: 22 }}>
        <table className="table" style={{ minWidth: 540 }}>
          <thead><tr><th>Invoice</th><th>Period</th><th>Amount</th><th>Status</th><th /></tr></thead>
          <tbody>
            <tr><td colSpan={5} className="kqc-muted">No invoices to show.</td></tr>
          </tbody>
        </table>
      </div>
      <p className="kqc-small kqc-muted">Wired to <strong>billingdb</strong> when it is built. The rail entry and this skeleton exist now so adding it later is one screen, not a navigation redesign.</p>
    </div>
  );
}
